<div
    class="alert alert-light border border-light-subtle mb-0 w-100"
    [class.h-100]="stretch"
    [class.d-flex]="stretch"
    [class.flex-column]="stretch"
    [class.justify-content-center]="stretch"
    role="status"
    data-testid="venue-not-in-service"
>
    <p class="fw-semibold mb-1">
        This venue is not currently available on TableSense.
    </p>
    <p class="mb-0 text-secondary">
        To enquire about a booking, please get in touch with the venue directly.
    </p>
</div>
